import type { MutationTree, Store } from "vuex";
import type { State } from "@/store/state";
import type { AssetState } from "./state";
import type { Asset } from "@/interfaces/assets";

export const mutations: MutationTree<AssetState> = {
  setAssets(state, assets: Asset[]): void {
    state.assets = assets;
  },
};

const NS = "assets/";

export const commitSetAssets = (
  store: Store<State>,
  payload: Asset[],
): void => {
  store.commit(`${NS}setAssets`, payload);
};
